import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Inject,
    Output,
} from '@angular/core';
import { Cms, ILink } from '@impact/data';
import { IMPACT_OVERLAY_DATA, ImpactOverlayRef } from '@impactdk/ngx-overlay';
import { closeLightIcon } from '../../../icons';

export interface IExternalBookingModalContent {
    carBrand?: string;
    externalBookingUrl?: string;
    pageContent?: Cms.BookWorkshopPage;
    regNumber?: string;
    forceExternalFlow?: boolean;
}

@Component({
    selector: 'app-book-workshop-external',
    template: `
        <div class="book-workshop-external" [ngClass]="{'optional-booking-flow': !data?.forceExternalFlow}">
            <div class="full-page-takeover-header-close book-workshop-external__close">
                <app-button buttonClass=" button button--round-with-icon" (click)="close()">
                    <i class="button__icon">${closeLightIcon}</i>
                </app-button>
            </div>
            <div class="book-workshop-external__content">
                <app-rich-text *ngIf="content" [html]="content"></app-rich-text>
            </div>
            <div class="book-workshop-external__actions">
                <app-button *ngIf="!data?.forceExternalFlow"
                    buttonClass="button button--tertiary"
                    (click)="overlayRef.close()"
                    [title]="data.pageContent?.externalBookingButtonStayOnSite"
                ></app-button>
                <app-button
                    [link]="link"
                    [target]="'_self'"
                ></app-button>
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookWorkshopExternalComponent {
    @Output() closeOverlay = new EventEmitter();
    link: ILink;
    content?: string;

    constructor(
        public overlayRef: ImpactOverlayRef,
        @Inject(IMPACT_OVERLAY_DATA) public data: IExternalBookingModalContent
    ) {
        this.link = {
            isExternal: true,
            url: data.externalBookingUrl || '',
            name: data.pageContent?.externalBookingButtonGoToExternalFlow || '',
        };

        if (this.data?.forceExternalFlow) {
            this.content = data.pageContent?.externalBookingOnly?.split('{{carBrand}}')?.join(data.carBrand)?.split('{{regNumber}}')?.join(data.regNumber);
        } else {
            this.content = data.pageContent?.externalBooking?.split('{{carBrand}}')?.join(data.carBrand)?.split('{{regNumber}}')?.join(data.regNumber);
        }
    }

    close() {
        this.overlayRef.close();
    }
}
